import { Drawer } from "vaul";
import { Cross1Icon } from "@radix-ui/react-icons";
import ChevronDown from "../../../../modules/icons/ChevronDown";
import { useEffect, useState } from "react";
import classNames from "classnames";
import Toggle from "../../../../modules/Toggle/Toggle";
import PartnerSelectionListItem from "./PartnerSelectionListItem";
import _ from "lodash";
import ImageLinks from "../../../../assets/Images/ImagesLink";
import Loader from "../../../../modules/Loader";
import { formatCurrencyCountry } from "../../../../resources/internationalizationUtils";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export const MOST_AFFORDABLE_PARTNER = "Most Affordable";
export const TOP_PARTNERS = "Top Partners";

function CartOrderDeliveryDetails({
  partnersList,
  isTitanAI,
  setTitanAI,
  titanPrice,
  titanNetwork,
  set_partner_fee_details,
}) {
  const [partnerSelectionType, setPartnerSelectionType] = useState();
  const [partnerSelection, setPartnerSelection] = useState();
  const [deliveryPartner, setDeliveryPartner] = useState("Titan AI");
  const [sorted_partners, set_sorted_partners] = useState(partnersList);
  const [sort_order, set_sort_order] = useState("asc");
  const userDetails = useSelector((state) => state.app.user_details);
  const currency_code = userDetails?.currency || "DEFAULT";
  const { t } = useTranslation();

  useEffect(() => {
    // if titan is selected
    // reset the partner selection
    if (isTitanAI) {
      setPartnerSelection();
      setPartnerSelectionType("Titan AI");
      set_partner_fee_details(titanNetwork);
    }
  }, [isTitanAI]);

  useEffect(() => {
    // if partner selection is selected
    // reset the titan
    if (partnerSelection !== undefined) {
      setTitanAI(false);
    }
  }, [partnerSelection]);

  useEffect(() => {
    setDeliveryPartner("Titan AI");
    setPartnerSelectionType("Titan AI");
  }, [partnersList]);

  useEffect(() => {
    set_sorted_partners(partnersList);
  }, [partnersList]);

  const isCTADisbaled = !isTitanAI && !partnerSelection;

  const handle_filter = () => {
    const nextOrder = sort_order === "asc" ? "desc" : "asc";

    const sorted = _.orderBy(
      partnersList,
      [(partner) => Number(partner?.quote?.price || 0)],
      [sort_order],
    );

    set_sorted_partners(sorted);
    set_sort_order(nextOrder);
  };

  return (
    <Drawer.Root>
      <Drawer.Trigger
        disabled={titanPrice === 0}
        className={`flex items-center cursor-pointer ${
          titanPrice === 0
            ? "opacity-50 pointer-events-none cursor-not-allowed"
            : ""
        }`}
      >
        <div className="text-stone-900 text-xs font-bold mr-1">
          {deliveryPartner}
        </div>
        <ChevronDown />
      </Drawer.Trigger>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/40" />
        <Drawer.Content className="bg-gray-100 flex flex-col rounded-t-[10px] mt-24 h-fit fixed bottom-0 left-0 right-0 outline-none">
          <div className="bg-white rounded-t-[10px] flex-1">
            {/* Header */}
            <div className="flex justify-between items-center px-5 pt-6">
              <Drawer.Title className="text-stone-900 text-sm font-bold font-custom">
                {t("delivery_details")}
              </Drawer.Title>
              <Drawer.Close>
                <Cross1Icon />
              </Drawer.Close>
            </div>

            <div className="px-5 mt-6 flex items-center">
              <div className="flex-1 mr-10 mb-2">
                <div className="flex items-center">
                  <div className="flex items-center gap-2">
                    <div className="text-stone-900 text-xs font-semibold">
                      Titan AI
                    </div>
                    <div className="w-px h-4 bg-neutral-900"></div>
                    <div className="text-stone-900 text-xs font-semibold">
                      {
                        formatCurrencyCountry(titanPrice, currency_code)
                          .formatedAmount
                      }
                    </div>
                  </div>
                  <div className="text-primary bg-[#E4DCF3] text-xs font-semibold px-2 py-1 ml-8 rounded-[30px]">
                    {t("recommended")}
                  </div>
                </div>
                <div className="text-stone-500 text-[10px] font-medium mt-1">
                  {t("with_smart_allocation")}
                </div>
              </div>
              <div>
                <Toggle onCheckedChange={setTitanAI} checked={isTitanAI} />
              </div>
            </div>

            <div className="mx-5 my-6 h-[1px] bg-neutral-200" />

            <div className="px-5 mt-6">
              <div
                className={`${isTitanAI ? "text-stone-500" : "text-stone-900"} text-xs font-semibold flex justify-between items-center`}
              >
                {t("partner_selection")}
                <div className="relative">
                  <button onClick={handle_filter}>
                    <img src={ImageLinks.filter} alt="sort" />
                  </button>
                </div>
              </div>

              {/* <div className="mt-4">
                <div className="inline-flex gap-3">
                  <button
                    onClick={() =>
                      setPartnerSelectionType(MOST_AFFORDABLE_PARTNER)
                    }
                    className={classNames(
                      "flex py-[10px] px-[30px] whitespace-nowrap font-custom text-xs rounded-full font-bold border border-1",
                      partnerSelectionType === MOST_AFFORDABLE_PARTNER
                        ? "text-violet-600 border-violet-600"
                        : "text-violet-600/50 border-violet-600/50"
                    )}
                  >
                    {MOST_AFFORDABLE_PARTNER}
                  </button>
                  <button
                    onClick={() => setPartnerSelectionType(TOP_PARTNERS)}
                    className={classNames(
                      "flex py-[10px] px-[30px] whitespace-nowrap font-custom text-xs rounded-full font-bold border border-1",
                      partnerSelectionType === TOP_PARTNERS
                        ? "text-violet-600 border-violet-600"
                        : "text-violet-600/50 border-violet-600/50"
                    )}
                  >
                    {TOP_PARTNERS}
                  </button>
                </div>
              </div> */}

              <div className="mt-4 max-h-[288px] overflow-y-auto p-1">
                <div className="space-y-3">
                  {sorted_partners?.length === 0 ? (
                    <Loader />
                  ) : (
                    _.map(sorted_partners, (partnerList) => (
                      <PartnerSelectionListItem
                        key={partnerList.id}
                        selected={
                          partnerSelectionType === partnerList.network_name
                        }
                        onClick={() => {
                          setPartnerSelection(1);
                          setPartnerSelectionType(partnerList.network_name);
                          set_partner_fee_details(partnerList);
                        }}
                        partnerList={partnerList}
                        isTitanAI={isTitanAI}
                      />
                    ))
                  )}
                </div>
              </div>
              <div className="flex items-center mt-4 gap-1">
                <img src={ImageLinks.info_gray} alt="icon" />
                <span className="text-xs text-[#666666] font-custom">
                  {t("surge_applicable")}
                </span>
              </div>
            </div>

            {/* CTA Button */}
            <div
              className={classNames("mt-9 mb-12 mx-5")}
              onClick={() => setDeliveryPartner(partnerSelectionType)}
            >
              <Drawer.Close
                disabled={isCTADisbaled}
                className="font-custom btn btn-block bg-[#492897] text-white rounded-[30px] text-base font-semibold disabled:cursor-not-allowed"
              >
                {t("confirm_allocation")}
              </Drawer.Close>
            </div>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}

export default CartOrderDeliveryDetails;
